import { Item } from '@/types/item/Item';

export enum OriginSystem {
    Chairish = 'CH',
}

export type ChairishItem = {
    imageUrl: string;
    lotId: string;
    lotUrl: string;
    originSystem: OriginSystem.Chairish;
    slug: string;
    startPrice: number;
    title: string;
};

export const isChairishItem = (item: ChairishItem | Item): item is ChairishItem =>
    'originSystem' in item && item.originSystem === OriginSystem.Chairish;

export type ChairishSimilarItemsSlice = {
    byId: { [itemId: number]: ChairishItem[] };
    loaded: { [itemId: number]: number };
    loading: boolean;
};

export const defaultChairishSimilarItemsSlice: ChairishSimilarItemsSlice = {
    byId: {},
    loaded: {},
    loading: false,
};
